/* eslint-disable */
import axios from "axios";
import { ErrorHandelFunctionApp } from "./ErrorHandelFunction";

export default async function getLayerId(
  serviceName,
  tableOrLayerName,
  options = {
    token: "",
    MapOrFeature: "MapServer",
  }
) {
  const { MapOrFeature, token } = options;
  try {
    // const url = `${
    //   process.env.REACT_APP_SERVICE_ENDPOINT
    // }/${serviceName}/MapServer?f=pjson${token ? `&token=${token}` : ""}`;
    const results = await axios.get(
      `${
        process.env.REACT_APP_SERVICE_ENDPOINT
      }/${serviceName}/${MapOrFeature}?f=pjson${token ? `&token=${token}` : ""}`
    );
    let id;
    const checkTable = results?.data?.tables?.find(
      (item) => item.name === tableOrLayerName
    );
    if (checkTable !== undefined) {
      id = checkTable.id;
    } else {
      const checkLayers = results?.data?.layers?.find(
        (item) => item.name === tableOrLayerName
      );
      if (checkLayers !== undefined) {
        id = checkLayers.id;
      } else {
        id = "-1";
      }
    }
    return id;
  } catch (error) {
    ErrorHandelFunctionApp(error)
    return ;
  }
}
